// treesListSlice.js
// Здесь будет описание редьюсера treesListSlice

export default function treesListSlice(state = {}, action) {
  switch (action.type) {
    default:
      return state;
  }
}
